import { useMemo } from "react"
import { flatten } from "shared/util"
import {
  Stack,
  SelectProps,
  FormControl,
  Select,
  MenuItem
} from "@mui/material"

import { SearchWordField } from 'components/controls/searchWordField'
import { SisetuListSortKey, SisetuSearchFlags } from "./types"

type SortKeyChoiceType = {
  value: SisetuListSortKey
  name: string
}

type SortKeySelectProps = {
  orderBy: SisetuListSortKey
  onChangeOrderBy: (value: SisetuListSortKey) => void
  list: SortKeyChoiceType[]
} & SelectProps
const SortKeySelect = ({
  orderBy,
  onChangeOrderBy,
  list,
  ...others
}: SortKeySelectProps) => (
  <FormControl>
    <Select
      {...others}
      id='kojinlist-orderby'
      size="small"
      value={orderBy}
      onChange={(event) =>
        onChangeOrderBy(event.target.value as SisetuListSortKey)
      }
    >
      {list.map(({ value, name }) => (
        <MenuItem key={`orderby-${value}`} value={value}>
          {name}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
)

type SisetuListBarProps = {
  searchFlags: SisetuSearchFlags
  searchWord: string
  onChangeSearchWord: (searchWord: string) => void
  orderBy: SisetuListSortKey
  onChangeOrderBy: (value: SisetuListSortKey) => void
}
export const SisetuListBar = ({
  searchFlags,
  searchWord,
  onChangeSearchWord,
  orderBy,
  onChangeOrderBy
}: SisetuListBarProps) => {
  const sortKeyList = useMemo<SortKeyChoiceType[]>(
    () => flatten([
      { value: "total", name: "総合スコア順" },
      searchFlags.hasDpc ? { value: "dpc", name: "DPCスコア順" } : null,
      searchFlags.hasCancer ? { value: "cancer", name: "がんスコア順" } : null,
      searchFlags.hasTrial ? { value: "trial", name: "治験スコア順" } : null,
      searchFlags.hasResearch ? { value: "research", name: "研究スコア順" } : null,
      searchFlags.hasJournal ? { value: "journal", name: "論文スコア順" } : null,
      searchFlags.hasSenmoni ? { value: "senmoni", name: "専門医スコア順" } : null,
      { value: "name", name: "名前順" },
    ]),
    [searchFlags]
  )
  return (
    <Stack direction="row" padding={1} spacing={1} alignItems="center" sx={{
      borderBottom: 1,
      borderColor: 'divider'
    }}>
      <SortKeySelect
        orderBy={orderBy}
        onChangeOrderBy={onChangeOrderBy}
        list={sortKeyList}
      />
      <SearchWordField
        id='search-word-sisetu'
        searchWord={searchWord}
        onChangeSearchWord={onChangeSearchWord}
        sx={{
          flexGrow: 1
        }}
      />
    </Stack>
  )
}